<script>
import { mapState } from 'vuex';

export default {
  name: 'AboutSection',

  computed: {
    ...mapState('strings', {
      about: state => state.marketing['about-us'],
    }),
  },

  created() {
    if (!this.about) {
      this.$store.dispatch('strings/getStringById', 'about-us');
    }
  },

  methods: {
    getApp() {
      const { $router, $store } = this;
      $router.push({ name: 'Install' });
      $store.dispatch('analytics/getAppClick', 'Landing_About_Us');
    },
  },
};
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="section about">
    <h2 class="section-title">
      About Us
    </h2>

    <div class="about-section">
      <v-sheet elevation="2" class="about-us-pic">
        <v-lazy>
          <picture>
            <source :srcset="require('@/assets/images/Mindy_Elena-600h.webp')" type="image/webp" />
            <source :srcset="require('@/assets/images/Mindy_Elena-600h.jpg')" type="image/jpeg" />
            <img :src="require('@/assets/images/Mindy_Elena-600h.jpg')" alt="App Screenshot" />
          </picture>
        </v-lazy>
      </v-sheet>

      <div class="description">
        <v-skeleton-loader type="text@10, sentences" :loading="!about">
          <div v-html="about ? about.content || '' : ''" />
        </v-skeleton-loader>

        <div class="button-container">
          <v-btn
            large
            depressed
            color="primary"
            :ripple="{ class: 'secondary--text' }"
            class="get-app-button"
            @click="getApp"
          >
            Get the app
          </v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.about {
  .section-title {
    margin-bottom: 2rem;

    .lg &,
    .xl & {
      width: 60%;
      margin-left: auto;
      margin-right: 0;
    }
  }

  .about-section {
    display: flex;

    .sm &,
    .md & {
      flex-direction: column;
      align-items: center;
    }
  }

  p {
    margin-bottom: 0.75rem;
  }

  .about-us-pic {
    height: fit-content;
    width: 200px;
    min-width: 200px;
    margin: 0 auto;
    padding: 10px;
    margin-bottom: 36px;
    border-radius: 0;

    img {
      height: auto;
      width: 100%;
    }
  }

  .description {
    width: 60%;

    .sm &,
    .md & {
      width: 100%;
    }
  }
}
</style>
